var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15368_1410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 0C2.25 0 0 2.25 0 5C0 7.75 2.25 10 5 10C7.75 10 10 7.75 10 5C10 2.25 7.75 0 5 0ZM6.98875 6.105C7.11063 6.22687 7.11063 6.425 6.98875 6.54688L6.54688 6.98875C6.425 7.11063 6.22687 7.11063 6.105 6.98875L5 5.88375L3.895 6.98875C3.77312 7.11063 3.575 7.11063 3.45312 6.98875L3.01125 6.54688C2.88937 6.425 2.88937 6.22687 3.01125 6.105L4.11625 5L3.01125 3.895C2.88937 3.77312 2.88937 3.575 3.01125 3.45312L3.45312 3.01125C3.575 2.88937 3.77312 2.88937 3.895 3.01125L5 4.11625L6.105 3.01125C6.22687 2.88937 6.425 2.88937 6.54688 3.01125L6.98875 3.45312C7.11063 3.575 7.11063 3.77312 6.98875 3.895L5.88375 5L6.98875 6.105Z",
    fill: "#D01A1A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15368_1410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelIcon);
export default __webpack_public_path__ + "static/media/cancel_Icon.f48f6dfdacbe1bd835a5c943389ec7c5.svg";
export { ForwardRef as ReactComponent };